import BaseModel from '../../util/model';

export default class WafCaptchaModel extends BaseModel {
  constructor(component) {
    super(component, { error: '' });
  }
}
